import React from 'react'

const SummaryRow = ({ label, value }) => (
	<div className='grid grid-cols-3 gap-3 py-2 border-b last:border-b-0'>
		<div className='col-span-1 text-sm font-medium text-gray-600'>{label}</div>
		<div className='col-span-2 text-sm text-gray-900 whitespace-pre-wrap'>{value || '-'}</div>
	</div>
)

const SummaryStep = ({ watch }) => {
	const values = watch()
	return (
		<div className='space-y-6'>
			<div>
				<h3 className='text-lg font-semibold mb-3 text-gray-800'>Basic</h3>
				<div className='bg-gray-50 rounded-md p-4'>
					<SummaryRow label='Title' value={values.title} />
					<SummaryRow label='Title (Ar)' value={values.titleAr} />
					<SummaryRow label='Description' value={values.description} />
					<SummaryRow label='Description (Ar)' value={values.descriptionAr} />
				</div>
			</div>

			<div>
				<h3 className='text-lg font-semibold mb-3 text-gray-800'>Job Details</h3>
				<div className='bg-gray-50 rounded-md p-4'>
					<SummaryRow label='Requirements' value={values.requirements} />
					<SummaryRow label='Requirements (Ar)' value={values.requirementsAr} />
					<SummaryRow label='Responsibilities' value={values.responsibilities} />
					<SummaryRow label='Responsibilities (Ar)' value={values.responsibilitiesAr} />
				</div>
			</div>

			<div>
				<h3 className='text-lg font-semibold mb-3 text-gray-800'>Position</h3>
				<div className='bg-gray-50 rounded-md p-4'>
					<SummaryRow label='Location' value={values.location} />
					<SummaryRow label='Location (Ar)' value={values.locationAr} />
					<SummaryRow label='Department' value={values.department} />
					<SummaryRow label='Department (Ar)' value={values.departmentAr} />
					<SummaryRow label='Employment Type' value={values.employmentType} />
					<SummaryRow label='Employment Type (Ar)' value={values.employmentTypeAr} />
					<SummaryRow label='Experience Level' value={values.experienceLevel} />
					<SummaryRow label='Experience Level (Ar)' value={values.experienceLevelAr} />
					<SummaryRow label='Application Deadline' value={values.applicationDeadline} />
					<SummaryRow label='Status' value={values.status} />
				</div>
			</div>

			<div>
				<h3 className='text-lg font-semibold mb-3 text-gray-800'>Compensation</h3>
				<div className='bg-gray-50 rounded-md p-4'>
					<SummaryRow label='Salary Min' value={values.salaryMin} />
					<SummaryRow label='Salary Max' value={values.salaryMax} />
					<SummaryRow label='Currency' value={values.currency} />
					<SummaryRow label='Negotiable' value={values.isNegotiable ? 'Yes' : 'No'} />
				</div>
			</div>

			<div>
				<h3 className='text-lg font-semibold mb-3 text-gray-800'>Other</h3>
				<div className='bg-gray-50 rounded-md p-4'>
					<SummaryRow label='Urgent' value={values.isUrgent ? 'Yes' : 'No'} />
					<SummaryRow label='Remote' value={values.isRemote ? 'Yes' : 'No'} />
					<SummaryRow label='Benefits' value={values.benefits} />
					<SummaryRow label='Benefits (Ar)' value={values.benefitsAr} />
					<SummaryRow label='Skills' value={values.skills} />
					<SummaryRow label='Skills (Ar)' value={values.skillsAr} />
					<SummaryRow label='Meta Title' value={values.metaTitle} />
					<SummaryRow label='Meta Title (Ar)' value={values.metaTitleAr} />
					<SummaryRow label='Meta Description' value={values.metaDescription} />
					<SummaryRow label='Meta Description (Ar)' value={values.metaDescriptionAr} />
					<SummaryRow label='Meta Keywords' value={values.metaKeyword} />
					<SummaryRow label='Meta Keywords (Ar)' value={values.metaKeywordAr} />
				</div>
			</div>

			{Array.isArray(values.questions) && values.questions.length > 0 ? (
				<div>
					<h3 className='text-lg font-semibold mb-3 text-gray-800'>Questions</h3>
					<div className='bg-gray-50 rounded-md p-4 space-y-3'>
						{values.questions.map((q, i) => (
							<div key={i} className='py-2 border-b last:border-b-0'>
								<div className='text-sm font-medium text-gray-800'>
									{i + 1}. {q.question || '-'}
								</div>
								{q.questionAr ? (
									<div className='text-sm text-gray-700 mt-1' dir='rtl'>
										{q.questionAr}
									</div>
								) : null}
								<div className='text-xs text-gray-600 mt-1'>
									Type: {q.type === 'dropdown' ? 'Dropdown' : 'Text'}
								</div>
								{q.type === 'dropdown' && Array.isArray(q.options) ? (
									<div className='text-xs text-gray-600 mt-1'>
										Options:{' '}
										{q.options
											.map((o) => (typeof o === 'string' ? o : o?.text))
											.filter(Boolean)
											.join(', ') || '-'}
									</div>
								) : null}
							</div>
						))}
					</div>
				</div>
			) : null}
		</div>
	)
}

export default SummaryStep
